import React from 'react';
import Table from '../../components/common/Table';
import { ReplyTemplateDTO } from '../../services/apiClient';
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime';
import { renderBooleanBadge } from '../../utils/displayUtils';

interface ReplyTemplateTableProps {
  data: ReplyTemplateDTO[];
  handleEdit: (row: ReplyTemplateDTO) => void;
  handleDelete: (row: ReplyTemplateDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const ReplyTemplateTable: React.FC<ReplyTemplateTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        {
          label: 'Title',
          key: 'title',
        },
        {
          label: 'Description',
          key: 'description',
        },
        {
          label: 'Component',
          key: 'componentActionId',
          render: (row: ReplyTemplateDTO) =>
                      <span>{row.component?.title || 'Unknown'}</span>,
        },
        {
          label: 'Active',
          key: 'isActive',
          render: (row: ReplyTemplateDTO) =>
            renderBooleanBadge(row.isActive ?? false),
        },
        {
          label: 'Position',
          key: 'displayPosition',
        },
        {
          label: 'Added',
          key: 'createdUtc',
          format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
        },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default ReplyTemplateTable;
